// The calculation lives in the shared, dependency-free module so that website
// and PDF can never drift apart: supabase/functions/_shared/player-stats.ts
export {
  computePlayerStats,
  formatKd,
  statsKey,
  MIN_SHOTS_FOR_ACCURACY,
  MIN_TAKEN_FOR_KD,
} from '@shared/player-stats';
export type { PlayerStats } from '@shared/player-stats';

import type { GameData, HitData } from '@/types/game';
import { computePlayerStats, type PlayerStats } from '@shared/player-stats';

export const computeStatsForGame = (gameData: GameData, hitData: HitData[] | null | undefined) =>
  computePlayerStats(gameData.players, hitData, gameData.teams);

/** Presentation-only helper — stays in the frontend. */
export const kdColorClass = (stats: PlayerStats) => {
  if (stats.unbeaten) return 'text-accent';
  if (stats.kd === undefined) return 'text-foreground';
  if (stats.kd >= 1.5) return 'text-accent';
  if (stats.kd < 0.7) return 'text-destructive';
  return 'text-foreground';
};
